import { Filter } from "./filter";

export class ByBranch extends Filter {
  constructor(public id?: number) {
    super("by.branch");
  }
}
